import {
  ENG_MONTHS,
  ENG_WEEKDAYS,
  COMMON_UI_ACTIONS,
  ATTENDANCE_STATUS,
  PERSON_NAME_FIELDS,
  STAFF_ROLES,
  COMMON_MESSAGES,
} from './constants'

export default {
  common: {
    appName: 'Chaild Preschool',
    welcome: 'Welcome',
    login: 'Login',
    logout: 'Logout',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    create: 'Create',
    search: 'Search',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    date: 'Date',
    previousDay: 'Previous Day',
    nextDay: 'Next Day',
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month',
    selectDate: 'SELECT DATE',
    update: 'Update',
    change: 'Change',
    download: 'Download',
    import: 'Import',
    export: 'Export',
    detail: 'Detail',
    all: 'All',
    required: 'This field is required.',
    maxChars: 'Please enter within {count} characters.',
    failed: 'Failed',
    homeScreen: 'Home Screen',
    loggedInAs: 'Logged in as',
    male: 'Male',
    female: 'Female',
    age: 'Age',
    yearsOld: '{n} years old',
    fiveAndAbove: '5 and above',
    gender: 'Gender',
    class: 'Class',
    unknownClass: 'Unknown class',
    unknown: 'Unknown',
    hour: 'h',
    minute: 'm',
    fiscalYear: 'School Year (SY)',
    schoolYear: 'SY',
    lastName: 'Last Name',
    firstName: 'First Name',
    name: 'Name',
    status: 'Status',
    completed: 'Completed',
    incomplete: 'Incomplete',
    sampleCsv: 'Sample CSV',
    csvFile: 'CSV File',
    selectedOnly: 'Selected children only',
    allChildren: 'All children',
    noChildrenSelected: 'No children selected',
    importCompleted: 'Import completed',
    importFailed: 'Import failed',
    exportStarted: 'Export has started.\nPlease check from the download list page.\n*It may take 1-2 minutes to complete.',
    exportFailed: 'Export failed',
    weekdays: ENG_WEEKDAYS,
    processing: 'Processing...',
  },

  mailbox: {
    broadcastMessages: 'Broadcast Messages',
    dateTime: 'Date & Time',
    title: 'Title',
    read: 'Read',
    detail: 'Detail',
    delete: 'Delete',
    noData: 'No messages found',
    recipients: 'Recipients',
    group: 'Group',
    body: 'Body',
    unreadCount: 'Unread Count',
    readCount: 'Read Count',
    readBy: 'Read By',
    schoolYear: 'SY',
    attachment: 'Attachment File',
    people: ' people',
  },

  memoru: {
    search: 'Search',
    albumList: 'Album List',
    upload: 'Upload',
    album: 'Album',
    photoDate: 'Photo Date',
    category: 'Category',
    dragDropHint: 'Add by drag & drop',
    published: 'Published',
    notPublished: 'Not Published',
    settings: 'Settings',
    minSalesCount: 'Min Sales Count',
    pieces: 'pieces',
    photoStartDate: 'Photo Start Date',
    photoEndDate: 'Photo End Date',
    serialNumber: 'Serial Number',
    total: 'Total',
    items: 'items',
    albumSettings: 'Album Settings',
    title: 'Title',
    schoolYear: 'School Year',
    releaseStartDate: 'Release Start Date',
    releaseStartTime: 'Release Start Time',
    releaseEndDate: 'Release End Date',
    releaseEndTime: 'Release End Time',
    comment: 'Comment',
    processing: 'Processing',
    completed: 'Completed',
    failed: 'Failed',
    albumUpdated: 'Album updated',
    confirmDelete: 'Delete?',
    uploadStarted: 'Upload has started',
  },

  navigation: {
    attendanceManagement: 'Attendance Management',
    napCheck: 'Nap Check',
    diary: 'Diary',
    mealPlan: 'Meal Plan & Inspection',
    growthRecord: 'Growth Record',
    childDevelopment: 'Child Development',
    events: 'Events',
    messaging: 'Messaging',
    accounting: 'Accounting',
    schoolService: 'School Services',
    staffAttendance: 'Staff Attendance',
    workScheduling: 'Work Scheduling',
    memoru: 'MEMORU',
    guidancePlan: 'Guidance Plan',
    newsletter: 'Newsletter',
    accountManagement: 'Account Management',
    schoolSettings: 'School Settings',
    others: 'Others',
  },

  features: {
    'nursery-web-attendance-list': 'Attendance List',
    'nursery-web-attendance-management': 'Check In & Check Out',
    'nursery-web-nap-list': 'Nap Check',
    'nursery-web-report-diary': 'Child Diary',
    'nursery-web-report-class-diary': 'Class Diary',
    'nursery-web-report-nursery-diary': 'School Diary',
    'nursery-web-report-nursery-hours-diary': 'Extended Childcare Diary',
    'nursery-web-report-diary-alert': 'Diary Alert Settings',
    'nursery-web-meal-plan': 'Meal Plan & Inspection',
    'nursery-web-growth-record': 'Growth Record',
    'nursery-web-child-development-record': 'Child Development',
    'nursery-web-ai-report': 'VEVO Report',
    'nursery-web-event-yearly-event': 'Events',
    'nursery-web-messaging-inbox': 'Messaging',
    'nursery-web-accounting-invoice': 'Invoice',
    'nursery-web-accounting-fee': 'Fee Setting',
    'nursery-web-accounting-cashbook': 'Cashbook',
    'nursery-web-accounting-nursery-hours-pattern': 'Nursery Hours Pattern',
    'nursery-web-school-service-list': 'School Services',
    'nursery-web-staff-attendance-list': 'Staff Attendance List',
    'nursery-web-staff-attendance-management': 'Staff Attendance Management',
    'nursery-web-work-scheduling-monthly-schedule': 'Monthly Staff Schedule',
    'nursery-web-work-scheduling-daily-schedule': 'Daily Schedule',
    'nursery-web-work-scheduling-shift-pattern': 'Shift Setting',
    'nursery-web-work-scheduling-attendance-schedule': 'Monthly Child Schedule',
    'nursery-web-work-scheduling-placement-setting': 'Placement Setting',
    'nursery-web-memoru-album': 'MEMORU',
    'nursery-web-guidance-plan-list': 'Guidance Plan List',
    'nursery-web-guidance-plan-form-setting': 'Form Setting',
    'nursery-web-guidance-plan-form-item-setting': 'Form Item Setting',
    'nursery-web-guidance-plan-master-setting': 'Master Setting',
    'nursery-web-letter-list': 'Newsletter',
    'nursery-web-account-management-children': 'Children',
    'nursery-web-account-management-staff': 'Staff',
    'nursery-web-school-setting-class': 'Class',
    'nursery-web-school-setting-group': 'Group',
    'nursery-web-school-setting-pasori': 'Pasori',
    'nursery-web-setting-download-list': 'Download',
    'nursery-web-setting-manual': 'Manual',
    'nursery-web-setting-system': 'System Settings',
    'nursery-web-setting-auth': 'Authorization',
    'nursery-web-setting-logout': 'Logout',
  },

  attendance: {
    title: 'Attendance Management',
    checkIn: 'Check In',
    checkOut: 'Check Out',
    checkInTime: 'Check-in Time',
    checkOutTime: 'Check-out Time',
    selectTime: 'Select Time',
    currentChildCount: 'Current Child Count',
    absent: 'Absent',
    attendanceStatus: 'Attendance Status',
    childName: 'Child Name',
    feverPrediction: 'Fever Prediction',
    fever: 'Fever Prediction',
    mildFever: 'Mild Fever Prediction',
    className: 'Class Name',
    editCheckInOut: 'Edit Check-in & Check-out',
    deleteCheckInOut: 'Delete Check-in & Check-out',
    registerAbsence: 'Register Absence',
    absenceConfirmDelete: 'Absence Confirmation & Delete',
    reason: 'Reason',
    comment: 'Comment',
    monthlyAttendance: 'Attendance Book (Monthly)',
    dailyAttendance: 'Attendance Book (Daily)',
    downloadMonthly: 'Download Monthly Attendance Book for {date}',
    downloadDaily: 'Download Daily Attendance Book for {date}',
    checkedIn: 'Checked in',
    checkedOut: 'Checked out',
    deleteAbsenceConfirm: 'Are you sure you want to delete this absence record?',
    deleteCheckInOutConfirm: 'Are you sure you want to delete the check-in/check-out record?',
    deleted: 'Deleted',
    saveFailed: 'Could not save. Cannot edit if sales information has been finalized.',
    siblingSettings: 'Sibling Settings',
    child: 'Child',
    statusItems: {
      all: 'All',
      attending: 'Scheduled Attendance',
      isAbsent: 'Scheduled Absence',
      inSchool: 'Arrived',
      wentHome: 'Departed',
      absenceReported: 'Absence Reported',
      absenceCancellationReported: 'Absence Cancellation Reported',
    },
    staffStatusItems: {
      isAbsent: 'Scheduled Absent',
      attending: 'Scheduled to Work',
      inSchool: 'Clocked In',
      wentHome: 'Clocked Out',
    },
    absenceReasons: {
      personal: 'Personal/Family Reasons',
      fever: 'Fever',
      infection: 'Infection',
      others: 'Others',
    },
    infectionTypes: {
      infStrep: 'Streptococcal Infection',
      infMycoplasma: 'Mycoplasma Pneumonia',
      infHFMD: 'Hand, Foot and Mouth Disease',
      infSlappedCheek: 'Fifth Disease (Erythema Infectiosum)',
      infStomach: 'Viral Gastroenteritis (Noro, Rota, Adeno, etc.)',
      infHerpangina: 'Herpangina',
      infRS: 'RS Virus Infection',
      infZoster: 'Shingles (Herpes Zoster)',
      infRoseola: 'Roseola (Exanthem Subitum)',
      infImpetigo: 'Impetigo',
      covid19: 'COVID-19',
    },
    selectDetail: 'Please select details',
    selectReason: 'Please select a reason',
    enterComment: 'Please enter a comment',
    commentMaxLength: 'Please enter a comment within 500 characters.',
    absenceRegistration: 'Absence Registration for {name}',
    detail: 'Details',
  },

  children: {
    title: 'Children & Parent Information',
    childInfo: 'Child Information',
    parentInfo: 'Parent Information',
    childRecord: 'Child Record',
    parentRecord: 'Parent Record',
    accountSettings: 'Account Settings',
    batchImport: 'Bulk Import',
    invitationPdf: 'Invitation PDF',
    childCsv: 'Child CSV',
    invitationDownload: 'Invitation Download',
    childDownload: 'Child Download',
    associationStatus: 'Association Status',
    quitSchool: 'Withdrawn',
    childName: 'Child Name',
    className: 'Class Name',
    genderHeader: 'Gender',
    ageHeader: 'Age',
    childrenParentsInfo: 'Children & Parents Info',
    childInformation: 'Child Information',
    childcareType: 'Childcare Type',
    regularChildcare: 'Regular Childcare',
    temporaryChildcare: 'Temporary Childcare',
    loginId: 'Login ID',
    initialPassword: 'Initial Password',
    childCode: 'Child Code',
    dateOfBirth: 'Date of Birth',
    admissionDate: 'Admission Date (Planned)',
    graduationDate: 'Graduation Date (Planned)',
    withdrawalDate: 'Withdrawal/Transfer Date',
    group: 'Group',
    extendedCarePattern: 'Extended Care Pattern',
    extendedPatternDefault: 'Extended Pattern',
    additionalStaffForSpecialNeeds: 'Additional Staff for Special Needs',
    maxSubsidyAmount: 'Max Subsidy Amount',
    loginInformation: 'Login Information',
    relationship: 'Relationship',
    loginMethod: 'Login Method',
    registeredEmail: 'Registered Email',
    emailAndPassword: 'Email & Password',
    deleteChildWarning: 'Warning!\nThis operation will delete all child information.\nYou risk losing all accumulated data in a single operation,\nso please be careful with this action.\n\n[ Notes on Deleting Child Information ] \n• This operation cannot be undone.\n• All current child information will be erased. For graduation or withdrawal, please enter the \'Graduation Date (Planned)\' instead.\n• If you still want to delete the child, please click the Delete button below.',
    deletedSuccessfully: 'Deleted successfully',
    createChildAccount: 'Create Child Account',
    editChildAccount: 'Edit Child Account',
    nurseryCodeNumber: 'Nursery Code/Number (Free Entry)',
    optionalCode1: 'Optional Code 1',
    optionalCode2: 'Optional Code 2',
    lastNameKatakana: 'Last Name (Katakana)',
    firstNameKatakana: 'First Name (Katakana)',
    parentTypes: {
      mother: 'Mother',
      father: 'Father',
      grandma: 'Grandmother',
      grandpa: 'Grandfather',
      aunt: 'Aunt',
      uncle: 'Uncle',
      sister: 'Sister',
      brother: 'Brother',
      other: 'Other',
    },
  },

  nap: {
    title: 'Nap Check List',
    templateList: 'Nap Template List',
    create: 'Create Nap Check',
    filterByDate: 'Filter by Date',
    startDate: 'Start Date',
    endDate: 'End Date',
    target: 'Target',
    interval: 'Interval (min)',
    headcount: 'Headcount',
    napEndTime: 'Nap End Time',
    allAges: 'All Ages',
    sensorScreen: 'Sensor Screen',
    createNapCheck: 'Create Nap Check',
    selectFromPattern: 'Select from Pattern',
    noPatternRegistered: 'No nap check patterns registered',
    select: 'Select',
    newCreate: 'New Create',
    recorder: 'Recorder',
    selectClass: 'Select Class',
    selectAge: 'Select Age',
    checkInterval: 'Check Interval',
    selectChildren: 'Select Children',
    selectIndividually: 'Select Individually',
    selectedChildren: 'Selected Children',
    deselect: 'Deselect',
    registerAsPattern: 'Register as Pattern',
    patternName: 'Pattern Name',
    confirmDelete: 'Are you sure you want to delete?',
    templateName: 'Template Name',
    napCheckCreationFailed: 'Error: Failed to create nap check',
    backToList: 'Back to List',
    napCheck: 'Nap Check',
    sensor: 'Sensor',
    endNap: 'End Nap',
    resumeNap: 'Resume Nap',
    withdrawApplication: 'Withdraw Application',
    comment: 'Comment',
    status: {
      inProgress: 'Napping',
      finished: 'Nap Ended',
      applied: 'Applied',
    },
    intervals: {
      five: '5 min',
      ten: '10 min',
      fifteen: '15 min',
      thirty: '30 min',
      sixty: '60 min',
    },
    confirmDeleteNap: 'Are you sure you want to delete?',
    deleteNap: 'Delete',
    deleteFailed: 'Delete failed',
    statusLabels: {
      none: 'Not yet',
      sleeping: 'Sleeping',
      awake: 'Awake',
      sleepIn: 'Fall Asleep',
      getUp: 'Wake Up',
    },
    postureChanges: {
      leftToUp: 'Left→Up',
      rightToUp: 'Right→Up',
      downToUp: 'Down→Up',
    },
    weather: 'Weather',
    temperatureHumidity: 'Temperature & Humidity',
    addTemperatureHumidity: 'Add Temperature & Humidity',
    time: 'Time',
    temperature: 'Temperature',
    humidity: 'Humidity',
    weatherOptions: {
      sunny: 'Sunny',
      cloudy: 'Cloudy',
      rainy: 'Rainy',
    },
    backToDetail: 'Back to Detail',
    addCheck: 'Add Check',
    alertSound: 'Alert Sound',
    scheduledCheck: 'Scheduled Check',
    applicant: 'Applicant',
    sensorConnectionComplete: 'Sensor connection completed',
    postureChange: 'Posture Change',
    staffInCharge: 'Staff in Charge',
    remarks: 'Remarks',
  },

  validation: {
    required: 'Required',
    pdfOnly: 'Only PDF files are allowed',
    tooShort: 'Text is too short',
    tooLong: 'Text is too long',
  },

  nurseryHours: {
    monthly: 'Monthly',
    spot: 'Spot',
    fixedTimeNursery: 'Fixed Time (Nursery)',
    fixedTimeKindergarten: 'Fixed Time (Kindergarten)',
    flexibleTime: 'Flexible Time',
    morningEveningCombined: 'Morning/Evening Combined',
    monthlyAndSpot: 'Monthly & Spot',
    extendedTimeFrame: 'Extended Time Frame',
    patternName: 'Pattern Name',
    monthlyOrSpot: 'Monthly/Spot',
    createdDate: 'Created Date',
    extendedPatternName: 'Extended Care Pattern Name',
    amount: 'Amount',
    extendedCareStartTime: 'Extended Care Start Time',
    regularCare: 'Regular Care',
    regularCareStartTime: 'Regular Care Start Time',
    shortenedCare: 'Shortened Care',
    shortenedCareStartTime: 'Shortened Care Start Time',
    groupFixedRate: 'Group Fixed Rate',
    applyGroupFixedRate: 'Apply Group Fixed Rate',
    extendedCareN: 'Extended Care {n}',
    timeSlotN: 'Time Slot {n}',
    standardExtendedTimeN: 'Standard Extended Period {n}',
    startTime: 'Start Time',
    endTime: 'End Time',
    earlyMorningExtension: 'Early Morning Extension',
    beforeShortenedCare: 'Before Shortened Care',
    afterShortenedCare: 'After Shortened Care',
    fixedTimeSlotKindergarten: 'Fixed Time Slots (Kindergarten)',
    defaultPatternTitle: 'Extended Care Pattern',
    createSuccess: 'Created successfully',
    saveSuccess: 'Saved successfully',
    perHour: 'Per Hour',
    perMonth: 'Per Month',
  },

  childReport: {
    childName: 'Child Name',
    className: 'Class Name',
    gender: 'Gender',
    age: 'Age',
    attendanceStatus: 'Attendance Status',
    edit: 'Edit',
  },

  guidance: {
    formMastSettings: 'Form Master Settings',
    duplicateToFormSettings: 'Duplicate to Form Settings',
    templateName: 'Template Name',
    type: 'Type',
    createdAt: 'Created At',
    duplicate: 'Duplicate',
    duplicateConfirm: 'Are you sure you want to duplicate?',
    duplicateSuccess: 'Duplication complete.\nPlease check the form settings screen.',
    title: 'Guidance Plan',
    detail: 'Guidance Plan Detail',
    approve: 'Approve',
    parentPlan: 'Parent Plan',
    name: 'Name',
    year: 'Year',
    month: 'Month',
    week: 'Week',
    updatedAt: 'Updated',
    director: 'Director',
    chief: 'Chief',
    personInCharge: 'Person in Charge',
    commaSeparated: 'Comma separated',
    itemName: 'Item Name',
    formTemplate: 'Form Template',
    formItemSettings: 'Form Item Settings',
    formItem: 'Form Item',
    itemType: 'Item Type',
    rowsVertical: 'Rows (Vertical Items)',
    colsHorizontal: 'Columns (Horizontal Items)',
    deleteConfirm: 'Are you sure you want to delete?',
    deletedSuccessfully: 'Deleted successfully',
    formTemplateSettings: 'Form Template Settings',
    formItems: 'Form Items',
    order: 'Order',
    addItem: 'Add Item',
  },
  foodMenu: {
    title: 'Meal Plan & Inspection',
    todayMenu: "Today's Menu - {date}",
    noMenuToday: "No menu registered for today.",
    inspected: 'Inspected',
    inspect: 'Inspect',
    importMenu: 'Import Menu',
    importStatus: 'Menu Import Status',
    reading: 'Reading',
    readError: 'Read Error',
    readComplete: 'Read Complete',
    date: 'Date',
    category: 'Category',
    categoryName: 'Category Name',
    menu: 'Menu',
    note: 'Notes',
    editTitle: 'Edit Menu',
    typeName: 'Type Name',
    targetClasses: 'Target Classes',
    selectCategory: 'Select Category',
    addCategory: 'Add Category',
    createNewCategory: 'Create New Category',
    createNewMenu: 'Create New Menu - {date}',
    create: 'Create',
    importMenuDialog: {
      title: 'Import Menu',
      selectFile: 'Please select a menu file',
      startImport: 'Start Import',
    },
    allergenFoods: 'Allergy Foods',
    allergenNames: {
      wheat: 'Wheat',
      soybean: 'Soybean',
      beef: 'Beef',
      egg: 'Egg',
      milk: 'Milk',
      peanut: 'Peanut',
      buckwheat: 'Buckwheat',
      shrimp: 'Shrimp',
      crab: 'Crab',
      mackerel: 'Mackerel',
      pork: 'Pork',
      chicken: 'Chicken',
      gelatin: 'Gelatin',
      orange: 'Orange',
      apple: 'Apple',
      peach: 'Peach',
      yam: 'Yam',
      squid: 'Squid',
      sesame: 'Sesame',
      walnut: 'Walnut',
      abalone: 'Abalone',
      salmonRoe: 'Salmon Roe',
      cashewNut: 'Cashew Nut',
      kiwiFruit: 'Kiwi Fruit',
      salmon: 'Salmon',
      banana: 'Banana',
      matsutake: 'Matsutake Mushroom',
      octopus: 'Octopus',
      scallop: 'Scallop',
      clam: 'Clam',
    },
    deleteConfirm: 'Are you sure you want to delete this menu?',
    inspection: 'Food Inspection',
    seasoning: 'Seasoning',
    firmness: 'Firmness',
    freshness: 'Freshness',
    arrangement: 'Arrangement',
    color: 'Color',
    quantity: 'Quantity',
    foreignMatter: 'Foreign Matter',
    heating: 'Heating',
    odor: 'Odor',
    taste: 'Taste',
    notes: 'Notes',
    testedBy: 'Tested By',
    testedAt: 'Tested At',
    updateTest: 'Update Inspection',
    appropriate: 'Appropriate',
    sweet: 'Sweet',
    salty: 'Salty',
    soft: 'Soft',
    hard: 'Hard',
    fresh: 'Fresh',
    good: 'Good',
    poor: 'Poor',
    beautiful: 'Beautiful',
    normal: 'Normal',
    more: 'More',
    less: 'Less',
    none: 'None',
    exists: 'Exists',
    proper: 'Proper',
    improper: 'Improper',
  },

  growthRecord: {
    title: 'Growth Record',
    listTitle: 'Growth Record List',
    showQuitChildren: 'Show withdrawn children',
    exportStarted: 'Growth record export has started.',
    checkDownloadPage: 'Please check from the {link}.',
    downloadPage: 'download page',
    childName: 'Child Name',
    quitDate: 'Quit Date',
    goToClassRecord: 'Go to Class Record',
    goToChildRecord: 'Go to Child Record',
    childRecordTitle: "{name}'s Growth Record",
    fiscalYearSuffix: 'SY',
    heightCm: 'Height (cm)',
    weightKg: 'Weight (kg)',
    remarks: 'Remarks',
    monthLabel: 'Month',
    heightUnit: 'cm',
    weightUnit: 'kg',
    percentileValue3: 'Percentile value 3%',
    percentileValue97: 'Percentile value 97%',
    height: 'Height (cm)',
    weight: 'Weight (kg)',
    percentileRangeLegend: 'Percentile range 3% ~ 97%',
    graphsHint: 'Enter growth record data to display the graphs.',
  },

  childDevelopment: {
    title: 'Development Records',
    importRecords: 'Import Development Records',
    exportDomainFields: 'Export Development Items',
    exportFieldClass: 'Export Class Assignments',
    fiscalYear: 'SY',
    className: 'Class Name',
    childName: 'Child Name',
    age: 'Age',
    edit: 'Edit',
    excelOutput: 'Excel Output',
    exportDevelopmentSheet: 'Export Development Record Sheet',
    exportProgressRecord: 'Export Progress Record',
    importDialog: {
      title: 'Import Development Records',
      selectFile: 'Please select a CSV file',
      domainFieldCsv: 'Development Items CSV',
      fieldClassCsv: 'Class Assignment CSV',
      startImport: 'Start Import',
    },
    developmentRecord: 'Development Record',
    progressRecord: {
      title: 'Progress Record',
      recordContent: 'What to Record',
      instructions: {
        title: 'Recording Guidelines',
        interest: 'What interests and concerns this child has',
        growth: 'What has the child become able to do compared to the last entry',
        play: 'What kind of play does the child engage in with friends',
        perspective: 'The child\'s qualities, character, and other aspects from your perspective',
      },
      month: 'Month',
      content: 'Record Content',
      edit: 'Edit',
      updatedDate: 'Updated Date',
      months: ENG_MONTHS,
    },
    unknown: 'Unknown',
    evaluationCriteria: 'Evaluation Criteria',
    achieved: 'Achieved',
    attempting: 'Attempting and showing progress',
    notAchieved: 'Not achieved',
    noItemsSet: 'No items have been set.',
    observationContent: 'Observation Content',
    observationPoint: 'Observation Point & Example',
    previousYearAchieved: 'Achieved in Previous Year',
    domain: 'Domain',
    item: 'Item',
    save: 'Save',
  },

  aiReport: {
    title: 'VEVO Report',
    titleIndividual: 'VEVO Report - Individual',
    titleQuarter: 'VEVO Report - {months} (SY {year}, Quarter {quarter})',
    titleQuarterFallback: 'VEVO Report - Quarter {quarter} (SY {year})',
    schoolYearOption: 'SY {year}',
    schoolYearLabel: 'SY {year} {months}',
    quarterLabel: 'Quarter {quarter}',
    topDescription:
      'Generate VEVO reports per child from development records for each quarter (3 months).',
    generating: 'Generating',
    generatingEllipsis: 'Generating...',
    regenerating: 'Regenerating',
    regeneratingEllipsis: 'Regenerating...',
    published: 'Published',
    draft: 'Draft',
    notGenerated: 'Not generated',
    openDetails: 'Open details',
    lastRun: 'Last run: {datetime}',
    emptyYearHint:
      'No reports have been generated for this school year yet. Open a quarter and run bulk generate.',
    bulkGenerate: 'Bulk generate',
    bulkGenerateTitle: 'Bulk generate VEVO reports',
    bulkGenerateStart: 'Start bulk generate',
    publishAllDrafts: 'Publish all drafts ({count})',
    exportCsv: 'Export CSV',
    batchGenerating: 'Generating batch {id}... ({success} / {total})',
    childrenCount: '{age} / {count} children',
    columns: {
      childName: 'Child name',
      status: 'Status',
      generations: 'Generations',
      achievedItems: 'Achieved items',
      progressRecords: 'Progress records',
      lastGenerated: 'Last generated',
      lastPublished: 'Last published',
      actions: 'Actions',
    },
    openReport: 'Open report',
    noChildrenInQuarter: 'No enrolled children in this quarter.',
    noClassesInQuarter: 'No classes found for this quarter.',
    confirmPublishAll:
      'Publish all {count} draft report(s)?\nParents will be notified.',
    publishSuccess: 'Published {count} report(s).',
    csvExportStarted:
      'CSV export started.\nCheck the download list screen.\nIt may take 1–2 minutes to complete.',
    csvExportFailed: 'CSV export failed.',
    targetQuarter: 'Target quarter: {months} (SY {year}, Quarter {quarter})',
    bulkHints: {
      newReports: 'New reports will be generated for children without one.',
      overwriteDrafts: 'Existing draft reports will be overwritten.',
      skipPublished: 'Published reports will be skipped (not overwritten).',
      async: 'This runs asynchronously and may take a few minutes.',
    },
    generatingProgress: 'Generating... {success} / {total}',
    failedCount: '(Failed: {count})',
    generationCompleted: 'Generation completed.',
    generationFailed: 'Generation failed.',
    regenerateCompleted: 'Regeneration completed.',
    regenerateFailed: 'Regeneration failed.',
    period: 'Period: {months}',
    coverageMonths: 'Development record months: {months}',
    coveragePartial: '(generated with partial month data)',
    coverageNone: 'None',
    generationsCount: 'Generations: {count}',
    reportBody: 'Report body',
    characters: '{count} characters',
    noReportYet:
      'No report yet. Use bulk generate from the quarter page, or press GENERATE below.',
    publish: 'Publish',
    revertToDraft: 'Revert to draft',
    regenerate: 'Regenerate',
    generate: 'Generate',
    generateTitle: 'Generate VEVO report',
    regenerateTitle: 'Regenerate VEVO report',
    cannotGenerateNoData: 'Cannot generate: no development records in this period',
    publishedSkipHint:
      'Published reports are skipped during bulk regenerate. Revert to draft first if you need to regenerate.',
    activityLog: 'Activity log',
    lastGenerated: 'Last generated:',
    lastPublished: 'Last published:',
    latestRegenerate: 'Latest regenerate',
    noTranslation: 'No translation (standard generate)',
    statusGuide: 'Status guide',
    statusNotGeneratedHint: 'Not generated (hidden from parents)',
    statusDraftHint: 'Generated but unpublished (hidden from parents)',
    statusPublishedHint: 'Visible in the parent app',
    regenerateIntroGenerate: 'Generate the report for {name}.',
    regenerateIntroRegenerate: 'Regenerate the report for {name}.',
    regenerateHints: {
      translate:
        'The current report body will be translated into the selected language and overwritten.',
      async:
        'This runs asynchronously and may take from tens of seconds to a few minutes.',
      backToDraft: 'When finished, the status will return to Draft.',
    },
    modeSimple: 'Simple regenerate (rebuild from development records)',
    modeTranslate: 'Translate (translate current body to selected language)',
    targetLanguage: 'Target language',
    startTranslation: 'Start translation',
    startGenerate: 'Start generate',
    startRegenerate: 'Start regenerate',
    generatingProgressShort: '{action}... ({success} / {total})',
    confirmPublish:
      'Are you sure you want to publish the report for {name}?\nParents will be notified.',
    confirmRevertDraft:
      'Are you sure you want to revert to draft the report for {name}?\nIt will no longer be visible to parents.',
    childFallback: 'Child',
  },

  calendar: {
    title: 'Yearly Event Schedule',
    fiscalYearSuffix: 'SY',
    dialog: {
      title: 'Event Settings',
      eventName: 'Event Name',
      class: 'Class',
      allDay: 'All Day',
      startDateRequired: 'Start Date*',
      date: 'Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      cancel: 'Cancel',
      create: 'Create',
      save: 'Save',
      delete: 'Delete',
      addSuccess: 'Event has been added.',
      saveSuccess: 'Event has been saved.',
      deleteSuccess: 'Event has been deleted.',
      failure: 'Operation failed.',
    },
  },

  admin: {
    title: 'School Settings',
    switchSchool: 'Switch School',
    nurseryName: 'Nursery Name',
    facilityCode: 'Facility Code',
    localAuthorityCode: 'Local Authority Code',
    postalCode: 'Postal Code',
    prefecture: 'Prefecture',
    address: 'Address',
    building: 'Building',
    phoneNumber: 'Phone Number',
    faxNumber: 'FAX Number',
    facilityEmail: 'Facility Email',
    companyName: 'Company Name',
    buildingRoom: 'Building & Room No.',
    representativeLastName: 'Representative Last Name',
    representativeFirstName: 'Representative First Name',
    representativeLastNameKana: 'Representative Last Name (Kana)',
    representativeFirstNameKana: 'Representative First Name (Kana)',
    changed: 'Changed',
    updated: 'Updated',
  },

  settings: {
    language: 'Language',
    switchLanguage: 'Switch Language',
    groupSettings: 'Group Settings',
    createGroup: 'Create Group',
    noGroups: 'No groups available',
    targetYear: 'Target Year',
    groupName: 'Group Name',
    createdDate: 'Created Date',
    userSettings: 'User Settings',
    staffSettings: 'Staff Settings',
    staffEdit: 'Edit Staff',
    staffAccountSettings: 'Staff Account Settings',
    staffForm: {
      category: 'Category *',
      categoryGeneral: 'General',
      categoryHelper: 'Helper',
      lastName: 'Last Name *',
      firstName: 'First Name *',
      lastNameKana: 'Last Name (Kana) *',
      firstNameKana: 'First Name (Kana) *',
      staffId: 'Staff ID *',
      staffIdTooltip: "Please enter in the format of alphabetic characters surrounding {'@'}.",
      staffIdExample: "Example: [Name in alphabet]{'@'}[Facility name in alphabet]",
      staffIdExampleValue: "onamae{'@'}shisetumei",
      staffIdWarning1: '* Please do not use a Staff ID that has been used before.',
      staffIdWarning2: '* Please do not register personal email addresses.',
      dateOfBirth: 'Date of Birth *',
      gender: 'Gender *',
      address: 'Address',
      phoneNumber1: 'Phone Number 1',
      phoneNumber2: 'Phone Number 2',
      phoneNumberPlaceholder: 'With hyphens',
      isDirector: 'Director',
      isChief: 'Chief',
      isAdmin: 'Administrator',
      adminTooltip: 'Administrator privileges allow editing of all items',
    },
    showHidden: 'Show Hidden',
    showRetired: 'Show Retired',
    bulkImport: 'Bulk Import',
    nameKana: 'Name (Kana)',
    assignmentDate: 'Assignment Date',
    retireDate: 'Retirement Date',
    classInCharge: 'Class in Charge',
    staffCategory: 'Staff Category',
    general: 'General',
    help: 'Help',
    position: 'Position',
    chief: 'Chief',
    director: 'Director',
    administrator: 'Administrator',
    staffCode1: 'Staff Code 1',
    staffCode2: 'Staff Code 2',
    birthDate: 'Birth Date',
    phoneNumber1: 'Phone Number 1',
    phoneNumber2: 'Phone Number 2',
    joinDate: 'Join Date',
    retireReason: 'Retirement Reason',
    retireReasonDetail: 'Retirement Reason Detail',
    remarks: 'Remarks',
    backToList: 'Back to List',
    importCompleted: 'Import completed',
    transfer: 'Transfer',
    retirement: 'Retirement',
    death: 'Death',
    warning: 'Warning',
    deleteStaffConfirm: 'Are you sure you want to delete this staff?',
    deletedSuccessfully: 'Deleted successfully',
    classSettings: 'Class Settings',
    createClass: 'Create Class',
    currentYear: 'Current Year',
    childrenDetail: 'Children Detail',
    duplicate: 'Duplicate',
    duplicateClass: 'Duplicate Class',
    useCheckboxes: 'Use checkboxes to assign/remove children from class',
    childrenAutoAssigned: 'Children from the source class will be automatically assigned to the duplicated class',
    className: 'Class Name',
    childrenAge: 'Children Age',
    classDuplicatedSuccessfully: 'Class duplicated successfully',
    savedSuccessfully: 'Saved successfully',
    classDialog: {
      title: 'Class Settings',
      className: 'Class Name',
      targetYear: 'School Year',
      year: 'SY',
      childrenAgeLabel: 'Class Children Age',
      yearsOld: 'years old',
      cancel: 'Cancel',
      delete: 'Delete',
      create: 'Create',
      update: 'Update',
      createSuccess: 'Class created successfully',
      updateSuccess: 'Class updated successfully',
      deleteConfirm: 'Are you sure you want to delete {className}?',
      deleteWarning: 'This action cannot be undone',
      deleteButton: 'Delete',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete',
    },
  },

  schoolDiary: {
    title: 'School Diary',
    createNew: 'Create New',
    dateStart: 'Date (Start)',
    dateEnd: 'Date (End)',
    unapproved: 'Unapproved',
    approved: 'Approved',
    draft: 'Draft',
    applied: 'Applied',
    approve: 'Approve',
    revokeApproval: 'Revoke Approval',
    saveAsDraft: 'Save as Draft',
    saveAndApply: 'Save & Apply',
    returnDraft: 'Return',
    applicant: 'Applicant',
    classDiaryList: 'Class Diary List',
    todaysAim: "Today's Aim",
    mainActivityAM: 'Main Activity (AM)',
    mainActivityPM: 'Main Activity (PM)',
    absentees: 'Absentees',
    childName: 'Child Name',
    className: 'Class Name',
    freeNotes: 'Free Notes',
    schoolEvents: 'School Events & Visitors',
    earlyLeavers: 'Early Leavers (Reason)',
    alreadyExists: 'A school diary for {date} already exists.',
    goToEditPage: 'Go to Edit Page',
    endDateEarlier: 'End date is earlier than start date',
    missingClassDiaries: 'There are class diaries that have not been created. Do you want to approve?',
  },

  schoolService: {
    title: 'School Services',
    monthlyUsage: 'School Services - Monthly Usage',
    perUsage: 'Per Usage',
    fixedMonthly: 'Fixed Monthly',
    usageMonthly: 'Usage Monthly',
    monthly: 'Monthly',
    editService: 'Edit Service',
    editNurseryService: 'Nursery-Provided Service - Edit',
    serviceName: 'Service Name',
    billingCondition: 'Billing Condition',
    unitPrice: 'Unit Price',
    limit: 'Limit',
    accountItem: 'Account Item',
    visibility: 'Visibility',
    hidden: 'Hidden',
    visible: 'Visible',
    hideTarget: 'Hide Target',
    deleteService: 'Delete Service',
    sameMonth: 'Same Month',
    nextMonth: 'Next Month',
    twoMonthsLater: 'Two Months Later',
  },

  classDiary: {
    title: 'Class Diary',
    createClassDiary: 'Create Class Diary',
    classDiaryList: 'Class Diary List',
    createNew: 'Create New',
    objective: 'Objective',
    activitiesMorning: 'Activities: Morning',
    activitiesAfternoon: 'Activities: Afternoon',
    evaluationReflection: 'Evaluation & Reflection',
    parentSupport: 'Parent Support',
    alreadyExists: 'diary already exists.',
    goToEditPage: 'Go to Edit Page',
  },

  systemSetting: {
    title: 'System Settings',
    refresh: 'Refresh',
    ccsHome: 'CCS HOME',
    parentChatPermission: 'Allow chat messages from parents',
    updated: 'Updated',
  },

  workScheduling: {
    shiftSetting: 'Shift Setting',
    shiftPatternSetting: 'Shift Pattern Setting',
    workContentSetting: 'Work Content Setting',
    monthlyChildSchedule: 'Monthly Child Schedule',
    dailySchedule: 'Daily Schedule',
    monthlyStaffSchedule: 'Monthly Staff Schedule',
    registerStaff: 'Register Staff',
    availableSubsidyHours: 'Hours available for children needing consideration',
    remainingHours: 'Remaining hours',
    download: 'Download',
    patternMode: 'Continuous Input Mode',
    updatePlacement: 'Update Placement Calculation',
    delete: 'Delete',
    bulkRegister: 'Bulk Register',
    selectAllStaff: 'Select all staff',
    monthlyStaffScheduleRegister: 'Register Monthly Staff Schedule',
    staffName: 'Staff Name',
    shiftPattern: 'Shift Pattern',
    editShiftPattern: 'Edit Shift Pattern',
    abbreviation: 'Abbreviation *',
    color: 'Color',
    holidayReason: 'Reason for absence',
    deleteTimeSlot: 'Remove time slot',
    addTimeSlot: 'Add time slot',
    addShiftPattern: 'Add Shift Pattern',
    timeSetting: 'Time Setting',
    item: 'Item',
    workDescription: 'Work Description',
    runPlacementCalc: 'Execute placement calculation?',
    placementCalcNote: 'Placement calculation takes about two minutes.',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    apply: 'Apply',
    requiredStaffMax: 'Required Staff (Difference) - Max',
    requiredStaffMin: 'Required Staff (Difference) - Min',
    days: 'Days',
    totalHours: 'Total Hours',
    paidLeave: 'Paid Leave',
    downloadStarted: 'Export has started. Please check from the download list page.',
    fetchError: 'Failed to load schedule data.',
    updateSuccess: 'Schedule has been updated.',
    updateFailed: 'Failed to update schedule.',
    patternApplySuccess: 'Pattern applied successfully.',
    patternApplyFailed: 'Failed to apply pattern.',
    shiftPatternSettings: {
      create: 'Create Shift Pattern',
      createTitle: 'Create Shift Pattern',
      editTitle: 'Edit Shift Pattern',
      deleteConfirm: 'Are you sure you want to delete {name}?',
      tableHeaders: {
        name: 'Shift Pattern Name',
        abbreviation: 'Abbreviation',
        color: 'Color',
      },
      form: {
        name: 'Name *',
        abbreviation: 'Abbreviation *',
        category: 'Category',
        workDescription: 'Work Description',
        timeSlot: 'Time Slot',
        time: 'Time',
        to: 'to',
      },
      categories: {
        workDescription: 'Work Content',
        break: 'Break',
        paidHoliday: 'Paid Leave',
        subsidyChildcare: 'Care for children needing consideration',
      },
    },
    workDescriptionSettings: {
      create: 'Create Work Content',
      createTitle: 'Create Work Content',
      editTitle: 'Edit Work Content',
      deleteConfirm: 'Are you sure you want to delete {name}?',
      tableHeaders: {
        name: 'Work Content Name',
        abbreviation: 'Abbreviation',
        childcareTarget: 'Childcare Target',
        color: 'Color',
      },
      form: {
        name: 'Work Content Name *',
        abbreviation: 'Abbreviation *',
        childcareTarget: 'Childcare Target',
      },
    },
    monthlyChild: {
      buttons: {
        patternSettings: 'Default Schedule Settings',
        bulkRegisterDefaults: 'Bulk Register Defaults',
        bulkRegister: 'Bulk Register',
      },
      filters: {
        class: 'Class',
      },
      tableHeaders: {
        childName: 'Child Name',
      },
      labels: {
        checkInTime: 'Check-in Time',
        checkOutTime: 'Check-out Time',
        arrivalTime: 'Arrival Time',
        departureTime: 'Departure Time',
      },
      defaultSchedule: {
        title: 'Default Attendance Schedule',
        deleteSelection: 'Delete Selected Defaults',
      },
      modals: {
        addTitle: 'Add Attendance Schedule',
        editTitle: 'Edit Attendance Schedule',
      },
      alerts: {
        noSelection: 'No items selected.',
        saveSuccess: 'Saved successfully.',
        deleteSuccess: 'Deleted successfully.',
      },
    },
    daily: {
      downloadDaily: 'Download (Daily)',
      downloadMonthly: 'Bulk Download (Monthly)',
      staffTab: 'Staff Schedule',
      childTab: 'Child Schedule',
      combinedTab: 'Staff & Child Schedule',
      displaySettings: 'Placement Display Settings',
      selectAll: 'Select All',
      staffLabel: 'Staff',
      classLabel: 'Class',
      childLabel: 'Children',
      updatePlacement: 'Update Placement Calculation',
      processing: 'Processing... ',
      placementCalcConfirm: 'Run placement calculation?',
      execute: 'Run',
      edit: 'Edit',
      breakOption: 'Break',
      placementCalcNoteShort: 'Placement calculation takes about 30 seconds.',
      overrideWarning: 'Cannot overwrite an existing schedule.\nPlease delete the existing entry before adding a new one.',
      childScheduleModalTitle: 'Edit Child Schedule',
      absenceReason: 'Reason for absence',
      commentRequired: 'Comment (required)',
      attendanceStatus: 'Attendance Status',
      checkInTime: 'Check-in Time',
      checkOutTime: 'Check-out Time',
      validation: {
        timeOrderInvalid: 'Cannot register when check-in and check-out times are reversed or identical.',
      },
      statusOptions: {
        attending: 'Present',
        absent: 'Absent',
      },
      statusIndicators: {
        present: 'In',
        absent: 'Abs',
      },
      displayItems: {
        plannedRequiredStaffGov: 'Planned: Required staff (National + Municipal support)',
        plannedRequiredStaffGovIndividual: 'Planned: Required staff (National + Municipal support + Individual child support)',
        plannedAssignedStaff: 'Planned: Assigned staff',
        actualRequiredStaffGov: 'Actual: Required staff (National + Municipal support)',
        actualRequiredStaffGovIndividual: 'Actual: Required staff (National + Municipal support + Individual child support)',
        actualAssignedStaff: 'Actual: Assigned staff',
        diffPlanned: 'Difference – Planned',
        diffActual: 'Difference – Actual',
        attendanceAge0: 'Projected attendance – Age 0',
        attendanceAge1: 'Projected attendance – Age 1',
        attendanceAge2: 'Projected attendance – Age 2',
        attendanceAge3: 'Projected attendance – Age 3',
        attendanceAge4: 'Projected attendance – Age 4+',
      },
      absenceReasons: {
        fever: 'Fever',
        personal: 'Family reasons',
        infStrep: 'Streptococcal infection',
        infMycoplasma: 'Mycoplasma pneumonia',
        infHFMD: 'Hand, foot and mouth disease',
        infSlappedCheek: 'Erythema infectiosum (Fifth disease)',
        infStomach: 'Viral gastroenteritis (Norovirus, Rotavirus, Adenovirus, etc.)',
        infHerpangina: 'Herpangina',
        infRS: 'RS virus infection',
        infZoster: 'Shingles',
        infRoseola: 'Roseola infantum',
        infImpetigo: 'Impetigo',
        others: 'Others',
      },
    },
    placementSetting: {
      title: 'Placement Setting',
      section1: {
        title: '① Child Age-based Settings',
        age: 'Age',
        setting: 'Setting',
        formula: 'Formula',
        age0: '0 years old',
        age1: '1 year old',
        age2: '2 years old',
        age3: '3 years old',
        age4Plus: '4 years old and above',
        staffLabel: 'Staff',
        perLabel: 'per',
        childrenLabel: 'children',
        childCountLabel: 'Number of children',
        commonCalc: 'Common calculation settings per age',
        decimalPoint: 'Decimal point',
        decimalFirst: 'First decimal place',
        decimalSecond: 'Second decimal place',
        roundDown: 'Round down',
        roundNormal: 'Round',
        roundUp: 'Round up',
      },
      section2: {
        title: '② Total',
        description: 'Round the first decimal place of the value obtained in ①',
        additionalFormula: '+ [Municipal additional allocation (③) + Additional staff for children requiring special care] = Required staff count',
        minimumNote: '* If the required staff count is less than 2, it will be set to 2.',
      },
      section3: {
        title: '③ Municipal Additional Allocation',
        additionalStaff: 'Municipal additional allocation',
        staffCount: 'staff',
        range: 'Range',
        from: 'from',
        to: 'to',
      },
      section4: {
        title: '④ Hourly wage for staff hired for children requiring special care',
        hourlyWage: 'Hourly wage',
        yen: 'yen',
      },
      save: 'Save',
    },
  },
  placementSetting: 'Placement Setting',
  shiftSetting: 'Shift Setting',
  shiftPatternSetting: 'Shift Pattern Setting',
  workContentSetting: 'Work Content Setting',

  nurseryHoursDiary: {
    activityContent: 'Activity Content',
    handoverContact: 'Handover & Contact',
    remarks: 'Remarks',
  },

  invoice: {
    schoolYear: 'School Year',
  },

  months: ENG_MONTHS,

  ui: {
    // Shared constants
    ...COMMON_UI_ACTIONS,
    ...ATTENDANCE_STATUS,
    ...PERSON_NAME_FIELDS,
    ...STAFF_ROLES,
    // UI-specific fields
    progressRecord: 'Progress Record',
    inputProgressRecord: 'Enter progress record',
    wakeUp: 'Wake Up',
    sleep: 'Sleep',
    billingMethod: 'Billing Method',
    billingTime: 'Billing Time',
    amount: 'Amount',
    limit: 'Limit',
    yen: '¥',
    perMinute: 'Per minute',
    hourly: 'Per hour',
    monthly: 'Per month',
    groupFixed: 'Group fixed rate',
    emailAddress: 'Email Address',
    noRecord: 'No record',
    saveFailed: 'Failed to save record',
    updateFailed: 'Failed to update record',
    deleteFailed: 'Failed to delete record',
    deleteSuccess: 'Deleted successfully',
    uploadFailed: 'Upload failed',
    exportStarted: 'Export started.\nPlease check the downloads list.\n*It may take 1-2 minutes to complete.',
    exportFailed: 'Export failed',
    patternConfigFailed: 'Failed to configure pattern',
    invalidTimeFrame: 'Invalid value entered. Please review the time frame settings and try again.',
    deviceConnectionFailed: 'Could not connect to the reading device. The driver may not be installed correctly.',
    sensorReadFailed: 'Sensor read failed. Please check if the sensor is properly set.',
    duplicateUsageInfo: 'Usage information is already registered. Please reload the screen and check.',
    lockedSalesInfo: 'Services cannot be edited because this month\'s sales information has been confirmed.',
    lockedSalesInfoForServices: 'Services for the target period cannot be edited because this month\'s sales information has been confirmed.',
    maintenanceMode: 'Maintenance Mode',
    currentlyMaintenance: 'Currently under maintenance. Please wait.',
    goToTopPage: 'Go to Top Page',
    defaultAttendanceSettings: 'Default Attendance/Dismissal Settings',
    corporateName: 'Corporate Name',
    postalCode: 'Postal Code',
    prefecture: 'Prefecture',
    address: 'Address',
  },

  pickers: {
    // Shared constants
    ...ATTENDANCE_STATUS,
    // Picker-specific fields
    year: 'Year',
    month: 'Month',
    day: 'Day',
    schoolYear: 'School Year',
  },

  staff: {
    // Shared constants
    ...PERSON_NAME_FIELDS,
    ...STAFF_ROLES,
    // Staff-specific fields
    settings: 'Staff Settings',
    emailAddress: 'Email Address',
    add: 'Add',
    classInChargeSettings: 'Class In Charge Settings',
  },

  pages: {
    maintenanceTitle: 'Maintenance Mode',
    maintenanceMessage: 'Currently under maintenance. Please wait.',
    pageNotFound: 'Page Not Found',
    pageNotFoundDesc: 'The specified page does not exist.',
    goToTopPage: 'Go to Top Page',
  },

  common_actions: {
    // Shared constants
    ...COMMON_UI_ACTIONS,
    // Action-specific fields
    close: 'Close',
    selectType: 'Select Type',
    addType: '+ Add Type',
    createInspection: 'Create Inspection',
    selectFile: 'Select File',
    draft: 'Draft',
    applied: 'Applied',
    inspected: 'Inspected',
    selectedChildrenOnly: 'Selected children only',
    allChildren: 'All children',
    monthlyUsageConfirmation: 'Monthly Usage Confirmation',
    paymentMonth: 'Payment Month',
    mainSubFeeFood: 'Main/Side Dish Fee',
    other: 'Other',
    deleteConfirmation: 'Are you sure you want to delete? This action cannot be undone.',
    readerInstruction: 'Connect the reader to your computer, place the reading device correctly on top of the reader, and then click the "Read" button below.',
    emailDuplicateError: '• Email address is duplicated with another user\n• Invalid input value\n• Other',
    defaultAttendanceSettings: 'Default Attendance/Dismissal Settings',
  },

  billing: {
    billingMethod: 'Billing Method',
    billingTime: 'Billing Time',
    amount: 'Amount',
    limit: 'Limit',
    perMinute: 'Per minute',
    yen: '¥',
    hourly: 'Hourly',
    monthly: 'Monthly',
    groupFixed: 'Group Fixed Rate',
  },

  errors: {
    E001: 'Required fields are missing or invalid. Please check your input.',
    E005: 'The specified ObjectType is invalid.',
    E006: 'Breakfast record does not exist.',
    E007: 'Breakfast record already exists.',
    E008: 'Dinner record does not exist.',
    E014: 'Childcare diary record does not exist.',
    E015: 'Childcare diary record already exists.',
    E021: 'Message not found.',
    E023: 'Class not found.',
    E024: 'The specified child was not found.',
    E050: 'The user does not belong to the specified preschool.',
    E051: 'This operation is only allowed for administrator users.',
    E090: 'Guardian not found.',
    E091: 'An allergy food with the same name is already registered.',
    E092: 'The specified allergy food does not belong to the specified preschool.',
    E093: 'Staff account role name already exists.',
    E094: 'Staff account role does not exist.',
    E095: 'Staff account information already exists.',
    E096: 'Staff account information does not exist.',
    E097: 'This staff account role is currently in use and cannot be deleted.',
    E098: 'The start date is set after the end date.',
    E099: 'The specified date is in the past.',
    E100: 'Failed to generate Excel file. Please contact the system administrator.',
    E101: 'Nap sensor is not activated.',
    E102: 'Nap sensor record not found.',
    E103: 'Absence registration not found.',
    E104: 'Chats created by others can only be viewed.',
    E105: 'The specified email address is already in use by another user and cannot be changed.',
    E106: 'Attachment not found.',
    E107: 'Certification/childcare fee record does not exist.',
    E108: 'Please enter the end date of the certification period.',
    E109: 'Invalid period for certification/childcare fee. Please check for overlaps with other periods.',
    E110: 'Target account item not found.',
    E111: 'The account item cannot be deleted because it is used in the petty cash book.',
    E112: 'Petty cash book detail record not found.',
    E113: 'An allergy item with the same name is already registered.',
    E114: 'Allergy item not found.',
    E115: 'The specified allergy item cannot be deleted or updated.',
    E116: 'Menu type not found.',
    E117: 'Menu not found.',
    E118: 'Food inspection not found.',
    E119: 'Food inspection has already been created.',
    E120: 'Extended care pattern not found.',
    E121: 'Cannot save because time frames overlap.',
    E122: 'Time frame not found.',
    E123: 'Clock-in settings do not exist.',
    E124: 'The specified extended care log does not belong to the specified preschool.',
    E125: 'The specified preschool-provided service is not registered in the master.',
    E126: 'The specified preschool-provided service is already registered.',
    E127: 'The specified preschool-provided service is not registered for use.',
    E128: 'For monthly facility-provided services, please set the 1st of the month as the usage date.',
    E129: 'The specified facility-provided service cannot be deleted because it is in use.',
    E130: 'Invalid serviceType format for facility-provided service.',
    E131: 'Invalid paymentMonthType format for facility-provided service.',
    E132: 'Invalid accountType format for facility-provided service.',
    E133: 'The user does not belong to the specified operating company.',
    E134: 'Operating company not found.',
    E135: 'The specified invoice does not exist.',
    E136: 'Invalid invoice status.',
    E137: 'The invoice has not been finalized yet.',
    E138: 'Failed to read the file. Please check the CSV file format.',
    E139: 'Invalid child code in CSV file.',
    E140: 'Invalid accounts receivable value in CSV file.',
    E141: 'Sales information export status does not exist.',
    E142: 'Accounts receivable balance import status does not exist.',
    E143: 'This attendance record cannot be edited because the sales information for this month has already been sent.',
    E144: 'A petty cash book with confirmed status cannot be changed.',
    E145: 'Childcare fee/certification information for the target period cannot be edited because this month\'s sales information has been finalized.',
    E146: 'The specified other service detail does not exist.',
    E147: 'There are children whose childcare fee/certification information is not registered. Please configure them before sending.',
    E148: 'The operating company\'s service settings do not exist.',
    E149: 'Cannot release the confirmed status of the petty cash book due to insufficient permissions.',
    E150: 'Cannot perform operation because the status is not draft.',
    E151: 'Preschool-provided services for the target period cannot be edited because this month\'s sales information has been finalized.',
    E152: 'Preschool\'s transfer account settings not found.',
    E153: 'Cannot register or edit because the specified child has graduated or withdrawn.',
    E154: 'The specified discussion was not found.',
    E159: 'Failed to generate PDF.',
    E160: 'Import/export status does not exist.',
    E161: 'No items to download.',
    E162: 'The specified delivery address does not exist.',
    E163: 'The specified item is not in the cart.',
    E164: 'The specified memoru unit price setting does not exist.',
    E165: 'The specified album does not exist.',
    E166: 'The specified media does not exist.',
    E167: 'The default delivery address cannot be deleted.',
    E168: 'The default delivery address is required.',
    E169: 'The specified task content does not exist.',
    E170: 'The specified task content is in use.',
    E171: 'The specified shift pattern does not exist.',
    E172: 'The specified shift pattern already exists.',
    E173: 'The specified timetable does not exist.',
    E174: 'Invalid timetable time.',
    E175: 'Timetable times are overlapping.',
    E176: 'Group settings not found.',
    E177: 'Invoice calculation is in progress. Please wait and try again.',
    E178: 'The specified file format is not supported.',
    E179: 'The specified media has already been purchased.',
    E180: 'Email address is not verified.',
    E181: 'Report master does not exist.',
    E182: 'Report item master does not exist.',
    E183: 'This report item master cannot be deleted.',
    E184: 'Report does not exist.',
    E185: 'Report item does not exist.',
    E186: 'This report item cannot be deleted.',
    E187: 'Guidance plan does not exist.',
    E188: 'This guidance plan cannot be deleted.',
    E189: 'An approved guidance plan cannot be edited.',
    E190: 'This guidance plan item cannot be edited.',
    E191: 'This guidance plan item is not linked to this guidance plan.',
    E192: 'This guidance plan item does not have child-specific text.',
    E193: 'You do not have permission to change the approval status of the guidance plan.',
    E194: 'You do not have permission to delete the guidance plan.',
    E235: 'Development item not found.',
    E236: 'Domain not found.',
    E237: 'Development record not found.',
    E238: 'Newsletter not found.',
    E239: 'Newsletter design not found.',
    E240: 'File not found.',
    E246: 'You do not have permission to perform this action.',
  },
  setting: {
    staffAccountSettings: 'Staff Account Settings',
    staffForm: {
      category: 'Category *',
      categoryGeneral: 'General',
      categoryHelper: 'Helper',
      lastName: 'Last Name *',
      firstName: 'First Name *',
      lastNameKana: 'Last Name (Kana) *',
      firstNameKana: 'First Name (Kana) *',
      staffId: 'Staff ID *',
      staffIdTooltip: "Please enter in the format of alphabetic characters surrounding {'@'}.",
      staffIdExample: "Example: [Name in alphabet]{'@'}[Facility name in alphabet]",
      staffIdExampleValue: "onamae{'@'}shisetumei",
      staffIdWarning1: '* Please do not use a Staff ID that has been used before.',
      staffIdWarning2: '* Please do not register personal email addresses.',
      dateOfBirth: 'Date of Birth *',
      gender: 'Gender *',
      address: 'Address',
      phoneNumber1: 'Phone Number 1',
      phoneNumber2: 'Phone Number 2',
      phoneNumberPlaceholder: 'With hyphens',
      isDirector: 'Director',
      isChief: 'Chief',
      isAdmin: 'Administrator',
      adminTooltip: 'Administrator privileges allow editing of all items',
      staffCode1: 'Staff Code 1',
      staffCode2: 'Staff Code 2',
      joinDate: 'Join Date *',
      assignDate: 'Assignment Date *',
      retireDate: 'Retirement Date',
      retireReason: 'Retirement Reason',
      retireReasonDetail: 'Reason Detail',
      classInCharge: 'Class in Charge',
      remarks: 'Remarks',
      isHidden: 'Hidden',
      retireTransfer: 'Transfer',
      retireRetire: 'Retirement',
      retireDie: 'Death',
      createSuccess: 'Created successfully',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Failed to save. Possible reasons below:',
      saveFailedEmail: 'Email is duplicated with other users',
      saveFailedInvalid: 'Invalid value input',
      saveFailedOther: 'Other',
      createFailed: 'Failed',
      errorTitle: 'Error',
      errorRequiredFields: 'Required fields are not filled',
    },
    classDialog: {
      title: 'Class Settings',
      className: 'Class Name',
      targetYear: 'School Year',
      year: 'SY',
      childrenAgeLabel: 'Class Children Age',
      yearsOld: 'years old',
      cancel: 'Cancel',
      delete: 'Delete',
      create: 'Create',
      update: 'Update',
      createSuccess: 'Class created successfully',
      updateSuccess: 'Class updated successfully',
      deleteConfirm: 'Are you sure you want to delete {className}?',
      deleteWarning: 'This action cannot be undone',
      deleteButton: 'Delete',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete',
    },
  },

  report: {
    atHome: 'At Home',
    atNursery: 'At Nursery',
    bowelMovement: 'Defecation',
    editDeleteRecord: 'Edit & Delete Record',
    time: 'Time',
    state: 'State',
    temperature: 'Temperature',
    amount: 'Amount',
    milk: 'Milk',
    activityRecord: 'Activity Record & Development',
    saveDraft: 'Save as Draft',
    morning: 'Morning',
    afternoon: 'Afternoon',
  },

  fee: {
    certificationSettings: 'Certification Settings',
    certificationNumber: 'Certification Number',
    certificationPeriodStart: 'Certification Period Start',
    certificationPeriodEnd: 'Certification Period End',
    sideDishFeeExemption: 'Side Dish Fee Full Exemption',
    childcareCertification: 'Childcare Certification',
    baseNurseryFee: 'Nursery Fee (Base)',
    nurseryFee: 'Nursery Fee',
    withdrawn: 'Withdrawn',
    fullExemption: 'Full Exemption',
    standardTax: 'Standard Tax',
    reducedTax: 'Reduced Tax',
    taxExempt: 'Tax Exempt',
    editing: 'Editing',
    finalized: 'Finalized',
  },

  mail: {
    editDraft: 'Edit Draft',
    title: 'Title',
    broadcastToClassGroup: 'Broadcast to Class/Group',
    selectChildrenBroadcast: 'Select children to broadcast',
    toClass: 'To (Class)',
    toGroup: 'To (Group)',
    addFromClass: 'Add children from class',
    addFromGroup: 'Add children from group',
    messageBody: 'Message Body',
    selectFiles: 'Select files (multiple allowed)',
    startDate: 'Start Date',
    endDate: 'End Date',
    searchTitle: 'Search Title',
  },

  letter: {
    editNewsletter: 'Edit Newsletter',
    issueDate: 'Issue Date',
    createdBy: 'Created By',
    className: 'Class Name',
    newsletterName: 'Newsletter Name',
    titleType: 'Title Type',
    fontSize: 'Font Size',
  },

  cashbook: {
    year: 'Year',
    month: 'Month',
    selectFile: 'Select a file',
  },

  staffAttendanceManagement: {
    clockInOut: 'Clock In & Clock Out',
  },

  batchLog: {
    status: 'Status',
    category: 'Category',
    updatedAt: 'Updated',
  },
}
